import { Bool, Obj, Str } from '@livecontrol/core-utils';

export interface TemporaryUser {
  email: string;
  emailVerified: boolean;
  name?: string;
  phoneNumber: string;
  phoneNumberVerified: boolean;
}

export namespace TemporaryUser {
  export interface Raw {
    email: string;
    email_verified: string;
    name: string;
    phone_number: string;
    phone_number_verified: string;
  }

  export const normalize = (value: unknown): TemporaryUser | undefined => {
    const candidate = Obj.normalize<Record<string, unknown>>(value);

    if (candidate) {
      // Required fields
      const temporaryUser = {
        email: Str.normalize(candidate.email),
        emailVerified: Bool.normalize(candidate.emailVerified),
        phoneNumber: Str.normalize(candidate.phoneNumber),
        phoneNumberVerified: Bool.normalize(candidate.phoneNumberVerified)
      };

      if (Obj.isHydrated(temporaryUser)) {
        return {
          ...temporaryUser,
          name: Str.normalize(candidate.name)
        };
      }
    }

    return undefined;
  };
}
